"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    hasPaper: {
      background: theme.palette.background.paper,
      border: "1px solid ".concat(theme.palette.divider),
      borderRadius: "2px",
      padding: "0"
    },
    noPaper: {
      padding: "0",
      backgroundColor: "inherit"
    },
    isSortable: {
      cursor: "move"
    },
    sideNav: {
      background: theme.palette.background.paper,
      "& .prmbl-touchRipple": {
        color: theme.palette.primary.main
      }
    }
  };
};

exports.styles = styles;